import React from "react";
import Svg, { G, Path, Circle } from "react-native-svg";

const StarBadge = ({ size, strokeWidth }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 91 91">
      <G
        id="badges"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <G id="1-copy-48" transform="translate(-142.000000, -474.000000)">
          <G id="Group-6" transform="translate(144.000000, 476.000000)">
            <Circle
              id="Oval"
              stroke="#FFE66D"
              strokeWidth={strokeWidth}
              fill="#F35F5F"
              cx="43.5"
              cy="43.5"
              r="43.5"
            />
            <G
              id="star-(4)"
              transform="translate(18.000000, 21.000000)"
              fillRule="nonzero"
            >
              <Path
                d="M45.0326536,14.089113 L31.7526221,12.8605233 L26.477389,0.64168159 C26.1080055,-0.213893863 24.8919196,-0.213893863 24.5226354,0.64168159 L19.2474023,12.8604242 L5.96737074,14.089113 C5.03745774,14.1750865 4.66171926,15.3287961 5.36325,15.9435862 L15.383075,24.7237832 L12.4507461,37.7019258 C12.2454006,38.6106899 13.229331,39.3236365 14.0322436,38.8481077 L25.5000122,32.0558013 L36.9677808,38.8481077 C37.7707927,39.3237355 38.7545245,38.6106899 38.5492783,37.7019258 L35.61685,24.7237832 L45.6367744,15.9435862 C46.3383051,15.3287961 45.9624673,14.1750865 45.0326536,14.089113 Z"
                id="Path"
                fill="#FFDC64"
              />
              <G id="Group" fill="#FFF082">
                <Path
                  d="M11.881207,0.789079268 C12.5603437,1.73222967 14.4772266,5.78269715 15.5731289,8.1432622 C15.7454531,8.51434756 15.2797793,8.84957927 14.9824453,8.56842683 C13.0911621,6.78052439 9.85734375,3.6779878 9.17820703,2.7347378 C8.64081445,1.98848374 8.81025,0.947930894 9.55672266,0.410623984 C10.3030957,-0.126682927 11.3438145,0.0428252033 11.881207,0.789079268 Z"
                  id="Path"
                />
                <Path
                  d="M39.118793,0.789079268 C38.4396562,1.73222967 36.5227734,5.78269715 35.4268711,8.1432622 C35.2545469,8.51434756 35.7202207,8.84957927 36.0175547,8.56842683 C37.9088379,6.78052439 41.1425566,3.67788821 41.821793,2.7347378 C42.3591855,1.98848374 42.18975,0.947930894 41.4432773,0.410623984 C40.6969043,-0.126682927 39.6561855,0.0428252033 39.118793,0.789079268 Z"
                  id="Path"
                />
                <Path
                  d="M49.8506074,28.4467907 C48.745541,28.0864614 44.3034609,27.4911911 41.7212871,27.1645244 C41.3153789,27.1131341 41.1374766,27.6586077 41.4955723,27.8564004 C43.7739375,29.1147642 47.712791,31.252439 48.8178574,31.6127683 C49.6922285,31.8979045 50.6322422,31.4203537 50.9174238,30.5460224 C51.2026055,29.6716911 50.7249785,28.7319268 49.8506074,28.4467907 Z"
                  id="Path"
                />
                <Path
                  d="M1.14939258,28.4467907 C2.25445898,28.0864614 6.69653906,27.4911911 9.27871289,27.1645244 C9.68462109,27.1131341 9.86252344,27.6586077 9.50442773,27.8564004 C7.2260625,29.1147642 3.28720898,31.252439 2.18214258,31.6127683 C1.30777148,31.8979045 0.367757812,31.4203537 0.0825761719,30.5460224 C-0.202605469,29.6716911 0.275021484,28.7319268 1.14939258,28.4467907 Z"
                  id="Path"
                />
                <Path
                  d="M23.8857305,47.2381911 C23.8857305,46.0760346 24.6970488,41.6690224 25.187127,39.1131545 C25.264125,38.7113943 25.8379746,38.7113943 25.9149727,39.1131545 C26.4050508,41.6690224 27.2163691,46.0760346 27.2163691,47.2381911 C27.2163691,48.1577378 26.470793,48.9031951 25.5510996,48.9031951 C24.6313066,48.9032947 23.8857305,48.1577378 23.8857305,47.2381911 Z"
                  id="Path"
                />
              </G>
              <Path
                d="M28,5.08497398 L26.1141254,0.641682245 C25.7509879,-0.213894082 24.5554651,-0.213894082 24.1924252,0.641682245 L19.0063922,12.8604374 L5.95101326,14.0891274 C5.03682436,14.175101 4.66743933,15.3288117 5.35710773,15.9436024 L15.2075053,24.7238084 L12.3247597,37.7019643 C12.1228865,38.6107293 13.0901794,39.3236766 13.8795154,38.8481473 L15.3799956,37.9441365 C17.8398617,21.7874324 24.7552883,9.92723092 28,5.08497398 Z"
                id="Path"
                fill="#FFC850"
              />
            </G>
          </G>
        </G>
      </G>
    </Svg>
  );
};

StarBadge.defaultProps = {
  size: 91,
  strokeWidth: 4,
};

export default StarBadge;
